import React from "react";
import { Link, useNavigate } from "react-router-dom";

import "./ResFooter.scss";
import "./Responsive.scss";
import logo from "./img/Logo.png";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";

function ResFooter() {
  const navigate = useNavigate();

  return (
    <div className="res-footer-card-con-nfc">
      <div className="res-footer-card-con-nfc-wrapper">
        <div className="res-footer-wrapper">
          <div className="res-footer-left-con">
            <div className="res-footer-left-con-prod">
              <h3>Products</h3>
              <Link to="/" className="footer-btn">
                Home
              </Link>
              <Link to="/digital-business-card" className="footer-btn">
                Digital Business Card
              </Link>
              <Link to="/best-nfc-business-card" className="footer-btn">
                NFC Business Card
              </Link>
              <Link to="/business-card" className="footer-btn">
                Smart Business Card
              </Link>
              <Link to="/electronic-business-card" className="footer-btn">
                Electronic Business Card
              </Link>
              <Link to="/virtual-business-card" className="footer-btn">
                Virtual Business Card
              </Link>
              <Link
                to="/digital-business-card-with-qr-code"
                className="footer-btn"
              >
                Digital Business Card with QR Code
              </Link>
              <Link to="/smart-contact-management" className="footer-btn">
                Smart Contact Management
              </Link>
              <Link to="/business-card-scanner" className="footer-btn">
                Business Card Scanner
              </Link>
              <Link to="/pricing" className="footer-btn">
                Pricing
              </Link>
              <Link to="https://leapon.me/login" className="footer-btn">
                Login
              </Link>
            </div>
            <div className="res-footer-left-con-prod">
              <h3>Resources</h3>
              <Link
                to="https://features.leapon.tech/"
                target="_blank"
                className="footer-btn"
              >
                Features
              </Link>
              <Link to="/privacy" className="footer-btn">
                Privacy
              </Link>
              <Link to="/blog" className="footer-btn">
                Blog
              </Link>
              <Link to="/terms-of-service" className="footer-btn">
                Terms of Service
              </Link>
            </div>
          </div>
          <div className="res-footer-left-con">
            <div className="res-footer-left-con-prod">
              <h3>Leapon</h3>
              {/* <Link to="/about" className="footer-btn">
                About us
              </Link> */}
              <Link to="/contact-sales" className="footer-btn">
                Contact us
              </Link>
            </div>
            <div className="res-footer-left-con-prod">
              <h3>Partners</h3>
              <Link className="footer-btn">University of Toronto</Link>
              <Link className="footer-btn">ICUBE</Link>
            </div>
          </div>
        </div>
        <div className="res-footer-right">
          <div className="res-footer-right-top">
            <Link
              to="https://www.linkedin.com/company/leapon/?viewAsMember=true"
              target="_blank"
              className="footer-social-btn"
            >
              <LinkedInIcon />
            </Link>
            <Link
              to="https://m.facebook.com/people/LeapoN/100089010861110/"
              target="_blank"
              className="footer-social-btn"
            >
              <FacebookIcon />
            </Link>
            <Link
              to="https://www.instagram.com/leapon.co/"
              target="_blank"
              className="footer-social-btn"
            >
              <InstagramIcon />
            </Link>
          </div>
          <button
            className="res-footer-right-bottom"
            onClick={() => navigate("/")}
          >
            <img
              loading="lazy"
              alt="logo"
              className="res-footer-right-logo"
              src={logo}
            />
            <p className="res-footer-right-txt">
              Incubated at <span>University of Toronto</span>
            </p>
          </button>
        </div>
      </div>
      <p className="Copyright">Copyright © 2025 Leapon. All rights reserved.</p>
    </div>
  );
}

export default ResFooter;
